<template>
  <v-card
    class="app-card"
    :class="{
      mobile: $vuetify.display.mobile,
      'shadow-always': shadowAlways,
      'radius-always': radiusAlways,
      'no-shadow': noShadow,
      'border-always': borderAlways
    }"
  >
    <template v-for="(index, name) in $slots" #[name]="slotProps">
      <slot v-bind="slotProps" :key="name" :name="name" />
    </template>
  </v-card>
</template>

<script>
export default {
  props: {
    shadowAlways: {
      type: Boolean,
      default: false
    },
    radiusAlways: {
      type: Boolean,
      default: false
    },
    noShadow: {
      type: Boolean,
      default: false
    },
    borderAlways: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-card {
  box-shadow: var(--shadow-1);
  border-radius: var(--rounded-app);
  border-color: var(--post-detail-15);

  &.border-always {
    border: 1px solid;
  }

  &.no-shadow {
    box-shadow: none !important;
  }

  :deep(.v-card-text) {
    line-height: inherit;
    letter-spacing: inherit !important;
  }

  :deep(.v-card-title) {
    line-height: inherit;
    letter-spacing: inherit;
    padding-top: 16px;
  }

  &.mobile {
    background-clip: padding-box;

    &:not(.shadow-always) {
      box-shadow: none;
    }

    &:not(.radius-always) {
      border-radius: 0;
    }
  }
}
</style>
